import * as Sentry from '@sentry/react';

type SentryEnv = {
  dsn?: string;
  environment?: string;
};

/**
 * DSN が設定されているときだけ Sentry を初期化する
 * @param options テストで送信を止めるためのもの。DSN などの設定は上書きさせない
 * @returns 初期化したかどうか
 */
const initSentry = (
  { dsn, environment }: SentryEnv,
  options: Pick<Sentry.BrowserOptions, 'beforeSend'> = {},
): boolean => {
  if (!dsn) {
    return false;
  }
  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    environment,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    ...options,
  });
  return true;
};

export default initSentry;
